import { createFileRoute } from '@tanstack/react-router'
import { TesteViagensXlsxPage } from '@/pages/teste-viagens-xlsx/TesteViagensXlsxPage'

export const Route = createFileRoute('/_auth/teste-viagens-xlsx')({
  component: TesteViagensXlsxPage,
})
